import * as React from "react"
export const HomeIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props} viewBox="0 0 24 24">
    <path
      fill="#000"
      fillRule="evenodd"
      d="M11.477 1.336a2 2 0 0 1 1.046 0c.397.108.732.37.999.58l.074.059L20.38 7.25l.077.06c.377.292.709.55.956.884a3 3 0 0 1 .477.975c.112.4.112.82.111 1.298v7.372c0 .527 0 .981-.03 1.356-.033.395-.104.789-.297 1.167a3 3 0 0 1-1.311 1.311c-.378.193-.772.264-1.167.296-.375.031-.83.031-1.356.031H6.16c-.527 0-.981 0-1.356-.03-.395-.033-.789-.104-1.167-.297a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167C2 18.82 2 18.365 2 17.838V10.468c0-.477-.001-.897.111-1.298a3 3 0 0 1 .477-.975c.247-.334.58-.592.956-.884l.077-.06 6.783-5.275a28.8 28.8 0 0 0 .074-.059c.267-.21.602-.472 1-.58Z"
      clipRule="evenodd"
    />
  </svg>
)
